import { Component, OnInit, OnChanges, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { DxDataGridComponent } from "devextreme-angular";
import { custom } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { LanguageService } from '../../../../../../../shared/services/language.service';
import { TimeService } from '../../../../../_api/services/time.service';
import { AmsNotifierService } from '../../../../../../../shared/services/ams-notifier.service';

@Component({
  selector: 'app-edit-transport-addition',
  templateUrl: './edit-transport-addition.component.html',
  styleUrls: ['./edit-transport-addition.component.css']
})
export class EditTransportAdditionComponent implements OnInit, OnChanges {
  @ViewChild('datagriddx', {static:false}) dataGrid: DxDataGridComponent;
  @Input() gridDataSource: any;
  additionTypeDataSource: any;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(project-portal.component) to show load indicator
  @Input() transport: any;
  @Input() newStatusId: number = 3;//Eirik 02.12.19 task 154 - status when inserting time posts
  @Input() newCategoryId: number = 8;//Eirik 02.12.19 task 154 - category when inserting time posts
  @Output() changed = new EventEmitter();
  isEditingDisabled = false;
  additionTypes: any; 

  newAddition: any = {
    AdditionTypeId: -1, 
    Value: null
  };

  validateAdditionTypeMessage = this.languageService.LNG("Please.Select.Additiontype"); 

  constructor(public languageService: LanguageService, private timeService: TimeService, private amsNotifierService: AmsNotifierService) { }

  ngOnInit() {
    this.timeService.getAdditionTypes()
      .subscribe((result: any) => { // success path
        this.additionTypes = result.Data; 
        this.additionTypeDataSource = new DataSource({
          store: new ArrayStore({
              data: result.Data,
              key: "AdditionTypeId",
          }),
          group: "AdditionTypeCategoryCode"
        });
      }, error => { // error path;
    });
  }

  ngOnChanges() {
    this.isEditingDisabled = this.transport.TransportStatusId >= 4;
  }

  onAdditionTypeChanged(e, cell) {
    let sel = e.component.option("selectedItem");
    if (sel) {
      let data = {
        AdditionTypeId: sel.AdditionTypeId,
        Code: sel.Code,
        UnitId: sel.UnitId,
        UnitCode: sel.UnitCode
      }
      cell.setValue(data);
    }
    else {
      cell.setValue(null);
    }
  }

  setAdditionTypeValue(newData, value) {
    newData.AdditionTypeId = value.AdditionTypeId;
    newData.Code = value.Code;
    newData.UnitId = value.UnitId;
    newData.UnitCode = value.UnitCode;
  }

  onEditorPreparing(e) {
    if(e.parentType == "dataRow"){

      e.editorOptions.onFocusIn = function(args) {
        const input = args.element.querySelector('.dx-texteditor-input');
        if (input !== null && input !== undefined) {
          input.select();
        }
      }
   }
  }

  createNewAddition() {
    this.loading.emit(true);
    let addition = {
      AdditionId: -1,
      AdditionTypeId: this.newAddition.AdditionTypeId,
      Value: this.newAddition.Value,
      CarrierId: this.transport.CarrierId,
      EmployeeId: this.transport.EmployeeId,
      Date: this.transport.Date,
      CategoryId: this.newCategoryId, 
      StatusId: this.newStatusId,
    };

    if (this.isValid()) {
      this.timeService.insertAddition(addition)
        .subscribe((result: any) => { 
          if (result.IsSuccess) {
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            this.newAddition = { AdditionTypeId: -1, Value: null }
            this.refresh();
          }
          else {
            this.loading.emit(false);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        }, error => {
          this.loading.emit(false);
      });
    }
    this.loading.emit(false); 
  }

  isValid(): boolean {
    let isValid: boolean = true; 
    
    if (this.newAddition.AdditionTypeId < 0) {
      this.amsNotifierService.error(this.validateAdditionTypeMessage);
      isValid = false; 
    }

    return isValid; 
  }

  refresh() {
    this.loading.emit(true);
    this.timeService.getAdditionsByTransportCollection(this.transport.TransportCollectionId)
      .subscribe((result: any) => { // success path

        this.loading.emit(false);
        if (result.IsSuccess) {
          this.gridDataSource = result.Data;
          this.changed.emit();
        }
        else {
          this.amsNotifierService.error(result.ErrorMessage);
        }
      }, error => { // error path;
        this.loading.emit(false);
      });
  }

  onRowUpdating(e) {
    const isCanceled = new Promise((resolve) => {
      this.loading.emit(true);
      for (var property in e.oldData) {
        if (!e.newData.hasOwnProperty(property)) {
          e.newData[property] = e.oldData[property];
        }
      }
      let addition = {
        AdditionId: e.newData.AdditionId,
        AdditionTypeId: e.newData.AdditionTypeId,
        Value: e.newData.Value,
        CarrierId: this.transport.CarrierId,
        EmployeeId: this.transport.EmployeeId,
        Date: this.transport.Date,
        CategoryId: 8,//transportcollection
      };

      this.timeService.updateAddition(addition)
        .subscribe((result: any) => { // success path
          this.loading.emit(false);
          if (result.IsSuccess) {
            resolve(false);
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            e.component.cancelEditData();
            this.refresh();
          }
          else {
            this.loading.emit(false);
            resolve(true);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        }, error => { // error path;
          this.loading.emit(false);
          resolve(true);
        });
    });
    e.cancel = isCanceled;
  }

  onRowRemoving(e: any) {
    let addtionIds: number[] = [];
    addtionIds.push(e.data.AdditionId); 
    
    this.timeService.deleteAdditionByAdditionIds(addtionIds).subscribe((result: any) => { 
      this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
      if (result.Message != null && result.Message.length > 0) {
        this.amsNotifierService.error(result.Message);
      }
      this.loading.emit(false);
      this.dataGrid.selectedRowKeys = [];
      this.refresh();
    }, error => { 
      this.loading.emit(false);
    });
  }
}
